module.exports = __webpack_public_path__ + "img/700.0e5451b7.jpg";